import React, { useState } from 'react';
import { supabase } from '../supabaseClient'; 

function BookingSection() {
  const [formData, setFormData] = useState({ 
    name: '', 
    email: '', 
    phone: '', 
    date: '', 
    time: '', 
    customTime: '',
    sessionType: 'Individual Therapy', // Default main type
    subType: '', // Notun state sub-category dhorar jonyo
    message: '' 
  });
  const [bookingStatus, setBookingStatus] = useState('idle');
  const [isCustomTime, setIsCustomTime] = useState(false);

  // Ekhane amra subTypes array add korechi Parinitar specialities onujayi
  const sessionCategories = [
    { 
      id: 'individual', 
      name: 'Individual Therapy', 
      duration: '45 Mins',
      subTypes: [
        'Depression & Anxiety',
        'Psychological Disorders',
        'Attachment Styles',
        'Drug Abuse Recovery',
        'Grief & Bereavement',
        'Wellness & Mindfulness'
      ]
    },
    { 
      id: 'couples', 
      name: 'Couples Counseling', 
      duration: '60 Mins',
      subTypes: [
        'Relationship Issues',
        'Pre-Marital Counseling',
        'Conflict & Communication',
        'Sexual Issues'
      ]
    },
    { 
      id: 'student', 
      name: 'Student Wellness', 
      duration: '45 Mins',
      subTypes: [
        'Academic Stress',
        'Career Anxiety',
        'Peer Pressure',
        'Focus & Concentration'
      ]
    }
  ];

  const availableSlots = ["10:00 AM", "12:00 PM", "03:00 PM", "05:00 PM"];

  // Find the currently selected category to display its sub-types
  const selectedCategoryObj = sessionCategories.find(cat => cat.name === formData.sessionType);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCategorySelect = (categoryName) => {
    // Jokhon main category change hobe, tokhon subType clear kore dite hobe
    setFormData(prev => ({
      ...prev,
      sessionType: categoryName,
      subType: '' // Resetting sub-type on category change
    }));
  };

  const handleSlotSelect = (time) => {
    setIsCustomTime(false);
    setFormData(prev => ({ ...prev, time, customTime: '' }));
  };

  const handleBookAppointment = async (e) => {
    e.preventDefault();
    const finalTime = isCustomTime ? formData.customTime : formData.time;
    
    if (!finalTime) {
      alert("Please select or enter a preferred time slot.");
      return;
    }

    if (!formData.subType) {
      alert("Please select a specific focus area (Sub-type) for your session.");
      return;
    }
    
    setBookingStatus('loading');

    // Database e save korar somoy Main Type ar Sub Type eksathe jure dicchi
    const combinedSessionType = `${formData.sessionType} (${formData.subType})`;

    const { error } = await supabase.from('appointments').insert([{
      user_name: formData.name,
      user_email: formData.email,
      phone_number: formData.phone,
      session_date: formData.date,
      session_time: finalTime,
      session_type: combinedSessionType,
      duration: selectedCategoryObj ? selectedCategoryObj.duration : '45 Mins',
      message: formData.message,
      status: 'pending'
    }]);

    if (error) {
      setBookingStatus('error');
    } else {
      setBookingStatus('success');
      setFormData({ 
        name: '', email: '', phone: '', date: '', time: '', 
        customTime: '', sessionType: 'Individual Therapy', subType: '', message: '' 
      });
      setIsCustomTime(false);
      setTimeout(() => setBookingStatus('idle'), 5000);
    }
  };

  return (
    <section id="booking" className="py-24 px-6 md:px-16 lg:px-24 bg-white">
      <div className="max-w-6xl mx-auto bg-deep-charcoal rounded-[3rem] shadow-2xl overflow-hidden flex flex-col lg:flex-row border-8 border-gray-50 relative z-10">
        
        {/* ================= LEFT INFO PANEL ================= */}
        <div className="lg:w-4/12 bg-ocean-teal p-10 md:p-14 text-white flex flex-col justify-between relative overflow-hidden">
          <div className="absolute top-[-20%] right-[-20%] w-96 h-96 bg-white opacity-5 rounded-full blur-3xl"></div>
          
          <div>
            <span className="text-xs font-black uppercase tracking-[0.3em] bg-white/20 px-4 py-2 rounded-full inline-block mb-8">Book a Session</span>
            <h3 className="text-4xl md:text-5xl font-serif font-bold mb-6 relative z-10 leading-tight">Schedule Your Visit.</h3>
            <p className="text-white/80 text-lg leading-relaxed relative z-10">
              All sessions are conducted <span className="font-bold text-white">Online (Video/Telephonic)</span>. Select your therapy type to see the specific areas we can cover.
            </p>
          </div>

          <div className="space-y-6 text-sm font-bold tracking-widest uppercase relative z-10 mt-12">
            <div className="flex items-center gap-4 border-b border-white/20 pb-6">
              <svg className="w-5 h-5 text-white/70" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
              <a href="mailto:parinitaduttaroy@gmail.com" className="hover:text-white transition-colors lowercase">parinitaduttaroy@gmail.com</a>
            </div>
            <div className="flex items-center gap-4">
              <svg className="w-5 h-5 text-white/70" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
              <span>+91 91637 65026</span>
            </div>
          </div>
        </div>

        {/* ================= RIGHT FORM PANEL ================= */}
        <div className="lg:w-8/12 p-10 md:p-14 bg-white">
          <form onSubmit={handleBookAppointment} className="space-y-8">
            
            {/* Step 1: Therapy Selection & Sub-types */}
            <div className="bg-gray-50 p-6 rounded-[2rem] border border-gray-100">
              <h4 className="text-sm font-black uppercase tracking-[0.2em] text-ocean-teal mb-6 flex items-center gap-2">
                <span className="w-6 h-6 rounded-full bg-ocean-teal text-white flex items-center justify-center text-[10px]">1</span> Therapy Type
              </h4>
              
              <div className="space-y-6">
                {/* Main Category Buttons */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                  {sessionCategories.map(cat => (
                    <button 
                      type="button" 
                      key={cat.id}
                      onClick={() => handleCategorySelect(cat.name)}
                      className={`px-4 py-4 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all border shadow-sm ${formData.sessionType === cat.name ? 'bg-ocean-teal text-white border-ocean-teal transform scale-[1.02]' : 'bg-white text-deep-charcoal border-gray-200 hover:border-ocean-teal/50'}`}
                    >
                      {cat.name} <br/> <span className={`mt-1 inline-block opacity-70 ${formData.sessionType === cat.name ? 'text-white' : 'text-gray-500'}`}>({cat.duration})</span>
                    </button>
                  ))}
                </div>

                {/* Conditionally Rendered Sub-type Dropdown */}
                {selectedCategoryObj && selectedCategoryObj.subTypes.length > 0 && (
                  <div className="animate-fade-in pt-2">
                    <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 pl-2 mb-2 block">Specific Focus Area</label>
                    <div className="relative">
                      <select 
                        name="subType" 
                        required
                        value={formData.subType} 
                        onChange={handleInputChange}
                        className="w-full px-6 py-4 rounded-xl bg-white border border-gray-200 focus:border-ocean-teal/50 focus:ring-4 focus:ring-ocean-teal/10 transition-all outline-none text-deep-charcoal font-bold appearance-none cursor-pointer shadow-sm"
                      >
                        <option value="" disabled>Select your primary concern...</option>
                        {selectedCategoryObj.subTypes.map(sub => (
                          <option key={sub} value={sub}>{sub}</option>
                        ))}
                      </select>
                      {/* Custom dropdown arrow */}
                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-6 text-ocean-teal">
                        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Step 2: Date & Time Scheduler */}
            <div className="bg-gray-50 p-6 rounded-[2rem] border border-gray-100">
              <h4 className="text-sm font-black uppercase tracking-[0.2em] text-ocean-teal mb-6 flex items-center gap-2">
                <span className="w-6 h-6 rounded-full bg-ocean-teal text-white flex items-center justify-center text-[10px]">2</span> Date & Time
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div className="space-y-3">
                    <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 pl-2">Preferred Date</label>
                    <input 
                      type="date" 
                      name="date" 
                      required 
                      value={formData.date} 
                      onChange={handleInputChange} 
                      min={new Date().toISOString().split('T')[0]} 
                      className="w-full px-6 py-4 rounded-xl bg-white border border-gray-200 focus:border-ocean-teal/50 focus:ring-4 focus:ring-ocean-teal/10 transition-all outline-none text-deep-charcoal font-bold cursor-pointer shadow-sm" 
                    />
                  </div>
                  <div className="space-y-3">
                    <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 pl-2">Select Slot</label>
                    <div className="flex flex-wrap gap-2">
                      {availableSlots.map(slot => (
                        <button 
                          type="button" 
                          key={slot}
                          onClick={() => handleSlotSelect(slot)}
                          className={`px-4 py-2.5 rounded-lg text-xs font-bold tracking-widest border transition-all shadow-sm ${!isCustomTime && formData.time === slot ? 'bg-ocean-teal text-white border-ocean-teal' : 'bg-white text-deep-charcoal border-gray-200 hover:border-ocean-teal/50'}`}
                        >
                          {slot}
                        </button>
                      ))}
                      <button 
                        type="button" 
                        onClick={() => {setIsCustomTime(true); setFormData({...formData, time: ''})}}
                        className={`px-4 py-2.5 rounded-lg text-xs font-bold tracking-widest border transition-all shadow-sm ${isCustomTime ? 'bg-ocean-teal text-white border-ocean-teal' : 'bg-white text-deep-charcoal border-gray-200 hover:border-ocean-teal/50'}`}
                      >
                        CUSTOM
                      </button>
                    </div>
                    {isCustomTime && (
                      <div className="mt-4 animate-fade-in">
                        <input 
                          type="time" 
                          name="customTime" 
                          required={isCustomTime} 
                          value={formData.customTime} 
                          onChange={handleInputChange} 
                          className="w-full px-6 py-4 rounded-xl bg-ocean-teal/5 border border-ocean-teal/30 focus:border-ocean-teal focus:ring-4 focus:ring-ocean-teal/10 transition-all outline-none text-deep-charcoal font-bold" 
                        />
                      </div>
                    )}
                  </div>
              </div>
            </div>

            {/* Step 3: Personal Details */}
            <div>
              <h4 className="text-sm font-black uppercase tracking-[0.2em] text-ocean-teal mb-6 flex items-center gap-2">
                <span className="w-6 h-6 rounded-full bg-ocean-teal text-white flex items-center justify-center text-[10px]">3</span> Your Details
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
                <input type="text" name="name" required value={formData.name} onChange={handleInputChange} className="w-full px-6 py-4 rounded-xl bg-[#FDFBF7] border border-gray-100 focus:border-ocean-teal/50 focus:ring-4 focus:ring-ocean-teal/10 transition-all outline-none font-medium shadow-sm" placeholder="Full Name" />
                <input type="tel" name="phone" required value={formData.phone} onChange={handleInputChange} className="w-full px-6 py-4 rounded-xl bg-[#FDFBF7] border border-gray-100 focus:border-ocean-teal/50 focus:ring-4 focus:ring-ocean-teal/10 transition-all outline-none font-medium shadow-sm" placeholder="WhatsApp Number" />
              </div>
              <input type="email" name="email" required value={formData.email} onChange={handleInputChange} className="w-full px-6 py-4 rounded-xl bg-[#FDFBF7] border border-gray-100 focus:border-ocean-teal/50 focus:ring-4 focus:ring-ocean-teal/10 transition-all outline-none font-medium shadow-sm mb-6" placeholder="Email Address" />
              <textarea name="message" rows="2" value={formData.message} onChange={handleInputChange} className="w-full px-6 py-4 rounded-xl bg-[#FDFBF7] border border-gray-100 focus:border-ocean-teal/50 focus:ring-4 focus:ring-ocean-teal/10 transition-all outline-none resize-none font-medium shadow-sm" placeholder="Briefly describe what you'd like to discuss (Optional)"></textarea>
            </div>

            <button 
              type="submit" 
              disabled={bookingStatus === 'loading' || bookingStatus === 'success'}
              className="w-full bg-deep-charcoal text-white font-black uppercase tracking-[0.2em] py-5 rounded-2xl hover:bg-ocean-teal shadow-xl hover:shadow-ocean-teal/20 disabled:opacity-70 transition-all active:scale-[0.98] flex justify-center items-center gap-3 mt-4"
            >
              {bookingStatus === 'loading' && <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>}
              {bookingStatus === 'loading' ? 'Processing...' : bookingStatus === 'success' ? 'Request Sent!' : 'Confirm Appointment'}
            </button>

            {bookingStatus === 'success' && (
              <div className="p-5 bg-green-50 text-green-800 rounded-2xl text-center text-sm font-bold border border-green-200 shadow-sm animate-fade-in flex flex-col items-center gap-2">
                <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                Thank you! Your request has been sent successfully. We will contact you shortly on WhatsApp to confirm the slot.
              </div>
            )}
            {bookingStatus === 'error' && (
              <div className="p-5 bg-red-50 text-red-800 rounded-2xl text-center text-sm font-bold border border-red-200 shadow-sm animate-fade-in">
                Oops! Something went wrong. Please try again later or contact directly via WhatsApp.
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}

export default BookingSection;